var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"testimonials"}},[_c('BadgeFilter',{attrs:{"slice":_vm.slice,"badges":_vm.badges},on:{"select":_vm.onSelect}}),_vm._v(" "),_c('ReviewList',{attrs:{"slice":_vm.slice,"badges":_vm.badges}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }